module.exports = __webpack_public_path__ + "static/scale-model-of-greensboro-history-museum-in-greensboro-north-carolina-63d7da073180fe841bf5fac31c9f87cb.png";